import React from 'react'
import PropTypes from 'prop-types'
import * as S from './Input.styled'

const Input = ({ isValid = true, inputRef = null, placeholderRaised = null, ...props }) => {
    if (placeholderRaised) {
        return (
            <S.Container>
                <S.InputPlacholderLabel isValid={isValid} {...props} ref={inputRef} required />
                <S.Label>{placeholderRaised}</S.Label>
            </S.Container>
        )
    }
    return <S.InputBase ref={inputRef} isValid={isValid} {...props} />
}

Input.propTypes = {
    isValid: PropTypes.bool,
    placeholderRaised: PropTypes.string,
    inputRef: PropTypes.object,
    borderColor: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    type: PropTypes.string
}

export default Input
